const IS_LOG = false;
const getDigits = (num) => {
  var digits = 0,
    parts = num.toString().split(".");

  if (parts.length === 2) {
    digits = parts[1].length;
  }

  return digits;
}

const toFixed = (num, digits) => {
  if (typeof digits == 'undefined') {
    return num;
  }

  return Number(num).toFixed(digits);
}

/**
 * [util 工具类]
 * @type {Object}
 */
const util = {
  isProd() {
    return process.env.NODE_ENV === 'production';
  },
  log(str) {
    // console.log(str);
    // fundebug.notify('test',str)  
    if (!this.isProd() && IS_LOG) {
      console.log(str);
    }
  },
  isArray(arr) {
    return Object.prototype.toString.call(arr) === '[object Array]';
  },
  getRadom(min, max) {
    return parseInt(Math.random() * (max - min + 1) + min, 10);
  },
  getViewWidth() {
    const doc = document
    const client = doc.compatMode === 'BackCompat' ? doc.body : doc.documentElement
    return client.clientWidth
  },
  getViewHeight(doc) {
    doc = document || doc
    const client = doc.compatMode === 'BackCompat' ? doc.body : doc.documentElement
    return client.clientHeight
  },
  //数字千分位
  toThousands(num) {
    var reg = /\d{1,3}(?=(\d{3})+$)/g;
    return (num + '').replace(reg, '$&,');
  },
  /**
   * [getParam 获取地址栏指定参数]
   * @param  {[type]} o [description]
   * @return {[type]}   [description]
   */
  getParam(o) {
    const reg = new RegExp(`(^|\\?|&|#)${o}=([^&#]*)(&|\x24|#)`, '')
    const url = location.href
    const match = url.match(reg)
    if (match) {
      return decodeURIComponent(match[2])
    }
  },
  queryToObject(query) {
    const obj = {};
    if (query) {
      const querys = query.split('&');
      querys.forEach((n) => {
        const keys = n.split('=');
        if (keys.length > 1) {
          obj[keys[0]] = keys[1];
        }
      })
    }
    return obj;
  },
  objectToQuery(query) {
    const params = [];
    for (let n in query) {
      params.push(n + "=" + query[n]);
    }
    return params.join("&");
  },
  getQueryUrl(url = '', params) {
    const query = this.objectToQuery(params);
    if (url.indexOf('?') >= 0) {
      return `${url}&${query}`;
    }
    return `${url}?${query}`;
  },
  urlQueryToObject(url) {
    const matchs = /.*\?+(.*)/.exec(url);
    if (matchs && matchs.length > 1) {
      const query = matchs[1];
      return this.queryToObject(query);
    }
    return {}
  },
  toStyleString(styles) {
    let stylesStr = ''
    for (let styleName in styles) {
      if (styles.hasOwnProperty(styleName)) stylesStr += `${styleName.replace(/([A-Z])/g, "-$1").toLowerCase()}:${styles[styleName]};`;
    }
    return stylesStr;
  },
  debounce(fn, delay) {
    var delay = delay || 200;
    var timer;
    return function () {
      var th = this;
      var args = arguments;
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(function () {
        timer = null;
        fn.apply(th, args);
      }, delay);
    };
  },
  throttle(func, wait, options) {
    var context, args, result;
    var timeout = null;
    // 上次执行时间点
    var previous = 0;
    if (!options) { options = {}; }
    // 延迟执行函数
    function later() {
      // 若设定了开始边界不执行选项，上次执行时间始终为0
      previous = options.leading === false ? 0 : Date.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) { context = args = null; }
    }
    return function (handle, data) {
      var now = Date.now();
      // 首次执行时，如果设定了开始边界不执行选项，将上次执行时间设定为当前时间。
      if (!previous && options.leading === false) { previous = now; }
      // 延迟执行时间间隔
      var remaining = wait - (now - previous);
      context = this;
      args = args ? [handle, Object.assign(args[1], data)] : [handle, data];
      // 延迟时间间隔remaining小于等于0，表示上次执行至此所间隔时间已经超过一个时间窗口
      // remaining大于时间窗口wait，表示客户端系统时间被调整过
      if (remaining <= 0 || remaining > wait) {
        clearTimeout(timeout);
        timeout = null;
        previous = now;
        result = func.apply(context, args);
        if (!timeout) { context = args = null; }
        // 如果延迟执行不存在，且没有设定结尾边界不执行选项
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result
    }
  },
  math: {
    Add: function (arg1, arg2, digits) {
      arg1 = arg1.toString(), arg2 = arg2.toString();

      var maxLen = Math.max(getDigits(arg1), getDigits(arg2)),
        m = Math.pow(10, maxLen),
        result = Number(((arg1 * m + arg2 * m) / m).toFixed(maxLen));

      return toFixed(result, digits);
    },
    /*
     函数：减法函数，用来得到精确的减法结果
     说明：函数返回较为精确的减法结果。
     参数：arg1：第一个加数；arg2第二个加数；d要保留的小数位数（可以不传此参数，如果不传则不处理小数位数
     调用：MathKit.Sub(arg1,arg2)
     返回值：两数相减的结果
     */
    Sub: function (arg1, arg2, digits) {
      return MathKit.Add(arg1, -Number(arg2), digits);
    },
    /*
     函数：乘法函数，用来得到精确的乘法结果
     说明：函数返回较为精确的乘法结果。
     参数：arg1：第一个乘数；arg2第二个乘数；d要保留的小数位数（可以不传此参数，如果不传则不处理小数位数)
     调用：MathKit.Mul(arg1,arg2)
     返回值：两数相乘的结果
     */
    Mul: function (arg1, arg2, digits) {
      // 数字化
      var num1 = parseFloat(arg1).toString(),
        num2 = parseFloat(arg2).toString(),
        m = getDigits(num1) + getDigits(num2),
        result = num1.replace(".", "") * num2.replace(".", "") / Math.pow(10, m);

      return toFixed(result, digits);
    },
    /*
     函数：除法函数，用来得到精确的除法结果
     说明：函数返回较为精确的除法结果。
     参数：arg1：除数；arg2被除数；d要保留的小数位数（可以不传此参数，如果不传则不处理小数位数)
     调用：MathKit.Div(arg1,arg2)
     返回值：arg1除于arg2的结果
     */
    Div: function (arg1, arg2, digits) {
      // 数字化
      var num1 = parseFloat(arg1).toString(),
        num2 = parseFloat(arg2).toString(),
        t1 = getDigits(num1),
        t2 = getDigits(num2),
        result = num1.replace(".", "") / num2.replace(".", "") * Math.pow(10, t2 - t1)

      return toFixed(result, digits);
    },
    getPerStr(arg1, arg2, digits) {
      return Number(util.math.Mul((arg1 / arg2), 100)).toFixed(digits)
    }
  },
  hasStorage() {
    const testKey = 'isEnable'
    const storage = window.localStorage
    let isEnable = false
    try {
      storage.setItem(testKey, '1')
      storage.removeItem(testKey)
      isEnable = true
    } catch (error) {
      console.info(error)
    }
    return isEnable
  },
  removeStorage(key) {
    return this.hasStorage && localStorage.removeItem(key)
  },
  setStorage(key, val) {
    if (!this.hasStorage()) {
      return
    }
    if (typeof val !== 'string') {
      val = JSON.stringify(val)
    }
    localStorage.setItem(key, val)
  },
  getStorage(key) {
    if (!this.hasStorage()) {
      return
    }
    let val = localStorage.getItem(key)
    let data
    if (!val) {
      return
    }
    try {
      return JSON.parse(val)
    } catch (err) {
      return (val)
    }
  },
  cookie(name, value, options) {
    if (typeof value !== 'undefined') {
      options = options || {}
      if (value === null) {
        value = ''
        options.expires = -1
      }
      let expires = ''
      if (options.expires && (typeof options.expires === 'number' || options.expires.toUTCString)) {
        let date
        if (typeof options.expires === 'number') {
          date = new Date()
          date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000))
        } else {
          date = options.expires
        }
        expires = `; expires=${date.toUTCString()}`
      }
      const path = options.path ? `; path=${options.path}` : ''
      const domain = options.domain ? `; domain=${options.domain}` : ''
      const secure = options.secure ? '; secure' : '';
      document.cookie = [name, '=', value, expires, path, domain, secure].join('')
    } else {
      let cookieValue = null
      if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';')
        for (let i = 0; i < cookies.length; i += 1) {
          const cookie = cookies[i].trim()
          if (cookie.substring(0, name.length + 1) === (`${name}=`)) {
            cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
            break
          }
        }
      }
      return cookieValue
    }
  },
  getMobileName(mobile) {
    let mobileName = ''
    if (mobile) {
      mobileName = mobile.substr(0, 3) + '****' + mobile.substr(7);
    }
    return mobileName;
  },
  formatMoney(num, noUnit) {
    if (!num) {
      return ''
    }
    num = num.toString();
    if (num.substr(num.length - 2) === '00') {
      const reVal = util.math.Div(num, 10000, 2).toString().replace(/([1-9]*)(\.\d?)([0]*)/, '$1$2');
      return noUnit ? reVal : reVal + '万'
    } else {
      return noUnit ? num : num + '元'
    }
  },
  /**
   * [date 日期相关操作]
   * @type {Object}
   */
  date: {
    secondsTo(s) {
      let m = Math.floor(s / 60);
      let f = s % 60;
      if (m < 10) {
        m = '0' + m;
      }
      if (f < 10) {
        f = '0' + f;
      }
      return [m, f, '00'].join(':')
    },
    getDay(year, month) {
      var d = new Date(year, month, 0);
      return d.getDate();
    },
    /**
     * [pad 日期补0]
     * @param  {[type]} source [description]
     * @param  {[type]} length [description]
     * @return {[type]}        [description]
     */
    pad: function (source, length) {
      let pre = "",
        negative = (source < 0),
        string = String(Math.abs(source));
      length = length || 2;
      if (string.length < length) {
        pre = (new Array(length - string.length + 1)).join('0');
      }

      return (negative ? "-" : "") + pre + string;
    },
    dateAdd(day) {
      const d = new Date();
      d.setDate(d.getDate() + 3);
      return d;
    },
    toDate(str) {
      if (str) {
        str = str.replace(/-/g, '/');
        str = str.indexOf('.') >= 0 ? str.slice(0, str.indexOf('.')) : str;
        str = new Date(str);
        return str
      }
    },
    formatTime(interval) {
      interval = interval | 0
      const minute = this.pad(interval / 60 | 0, 2);
      const second = this.pad(interval % 60, 2);
      return `${minute}:${second}`
    },
    /**
     * [format 日期格式化]
     * @param  {[type]} source  [description]
     * @param  {[type]} pattern [description]
     * @return {[type]}         [description]
     */
    format(source, pattern) {
      if (!source) {
        return;
      }
      if ('string' != typeof pattern) {
        return source.toString();
      }
      if ('string' == typeof source) {
        source = source.replace(/-/g, '/');
        source = source.indexOf('.') >= 0 ? source.slice(0, source.indexOf('.')) : source;
        source = new Date(source);
      }

      function replacer(patternPart, result) {
        pattern = pattern.replace(patternPart, result);
      }

      let pad = util.date.pad,
        year = source.getFullYear(),
        month = source.getMonth() + 1,
        date2 = source.getDate(),
        hours = source.getHours(),
        minutes = source.getMinutes(),
        seconds = source.getSeconds();

      replacer(/yyyy/g, pad(year, 4));
      replacer(/yy/g, pad(parseInt(year.toString().slice(2), 10), 2));
      replacer(/MM/g, pad(month, 2));
      replacer(/M/g, month);
      replacer(/dd/g, pad(date2, 2));
      replacer(/d/g, date2);

      replacer(/HH/g, pad(hours, 2));
      replacer(/H/g, hours);
      replacer(/hh/g, pad(hours % 12, 2));
      replacer(/h/g, hours % 12);
      replacer(/mm/g, pad(minutes, 2));
      replacer(/m/g, minutes);
      replacer(/ss/g, pad(seconds, 2));
      replacer(/s/g, seconds);

      return pattern;
    }
  },

  // 年级转化
  gradeNumToText(num) {
    const gradeObj = {
      1: "一年级",
      2: "二年级",
      3: "三年级",
      4: "四年级",
      5: "五年级",
      6: "六年级",
      7: "初一",
      8: "初二",
      9: "初三",
      10: "高一",
      11: "高二",
      12: "高三",
    };
    return gradeObj[num] || "未知年级";
    },
};
export default util
